import React, { useState, useEffect } from "react";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import BookingPatientCard from "./BookingPatientCard";
import Loading from "../../common/Loading";
import bookingService from "../../../services/booking.service";
import Pagination from "../../common/Pagination";

const BookingRequests = ({updateTabTotal,bookingstatus=5}) => {
    const [loading, setLoading] = useState(false);
    const clinicId = useEyeconxStore((state) => state.user.clinicId);

    const [patientRequests, setPatientRequests] = useState([]);
    const [pageNo, setPageNo] = useState(0);
    const [pageSize] = useState(5);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    // Search states
    const [searchColumn, setSearchColumn] = useState("firstName");
    const [searchValue, setSearchValue] = useState("");
    const [activeSearch, setActiveSearch] = useState("");

    useEffect(() => {
        fetchBookingRequests(pageNo);
    }, [pageNo, activeSearch]);

    const fetchBookingRequests = async (page) => {
        setLoading(true);
        try {
            // base query
            let query = "status="+bookingstatus;

            // append search params if active
            if (activeSearch) {
                query += `&column=${searchColumn}&value=${encodeURIComponent(activeSearch)}`;
            }

            const res = await bookingService.getBookingRequests(
                clinicId,
                page,
                pageSize,
                query
            );

            const data = res.data;
            setPatientRequests(data.content || []);
            setTotalPages(data.totalPages || 0);

            if(bookingstatus ===0) updateTabTotal(data.totalElements);

            setTotalElements(data.totalElements || 0);
        } catch (error) {
            console.error("Error fetching booking requests:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdate = ()=>{
        console.log("fecth called");
        fetchBookingRequests(pageNo);
    }
    // Pagination change
    const handlePageChange = (newPage) => {
        setPageNo(newPage);
    };

    // Handle search submit
    const handleSearch = (e) => {
        e.preventDefault();
        setPageNo(0);
        setActiveSearch(searchValue.trim());
    };

    // Handle reset search
    const handleClearSearch = () => {
        setSearchValue("");
        setActiveSearch("");
        setPageNo(0);
    };

    return (
        <div>
            {/* Header + Search */}
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                <h5 className="mb-2 mb-md-0">Total ({totalElements})</h5>

                <form
                    className="d-flex flex-row align-items-center gap-2 mb-2"
                    onSubmit={handleSearch}
                >
                    <select
                        className="form-select form-select-sm w-auto"
                        value={searchColumn}
                        onChange={(e) => setSearchColumn(e.target.value)}
                    >
                        <option value="firstName">First Name</option>
                        <option value="lastName">Last Name</option>
                        <option value="preferredName">Preferred Name</option>
                        <option value="cellPhone">Cell Phone</option>
                        <option value="homePhone">Home Phone</option>
                    </select>

                    <input
                        type="text"
                        placeholder="Search value"
                        className="form-control form-control-sm"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    />

                    <button
                        type="submit"
                        className="btn btn-sm btn-primary d-flex align-items-center text-white"
                        disabled={loading}
                    >
                        <i className="bi bi-search me-1"></i> Search
                    </button>

                    {activeSearch && (
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={handleClearSearch}
                        >
                            <i className="bi bi-x-circle"></i>
                        </button>
                    )}
                </form>
            </div>

            {/* Data List */}
            {loading ? (
                <Loading />
            ) : (
                <div className="row mt-3">
                    <div className="col-12">
                        {patientRequests && patientRequests.length > 0 ? (
                            patientRequests.map((patient) => (
                                <BookingPatientCard
                                    key={patient.id}
                                    request={patient}
                                    bookingstatus={bookingstatus}
                                    handleUpdate={handleUpdate}
                                />
                            ))
                        ) : (
                            <p className="text-muted">No requests found.</p>
                        )}
                    </div>
                </div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="row">
                    <div className="col-12">
                        <Pagination
                            currentPage={pageNo}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            totalElements={totalElements}
                            pageSize={pageSize}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default BookingRequests;
